module.exports = __webpack_public_path__ + "img/video.fe643dfc.png";